module.exports = __webpack_public_path__ + "img/bomb.7179fa78.png";